export default __webpack_public_path__ + "static/media/triangle-area.70bf648c.svg";